export default __webpack_public_path__ + "static/media/a7.d08ba1fb.png";